import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { Button } from "~/features/ui/button";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
import { isLinkValid } from "~/features/ui/link/utils";
const fragment = graphql(`
  fragment LandingAdditionalNavDrawerLink on navDrawerAdditionalLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function AdditionalNavDrawerLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  const icon = useLinkIcon(link);
  if (!isLinkValid(link)) {
    return null;
  }
  return <Button as={Link} variant="secondary" {...link} icon={icon} />;
}